import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthService } from '@app/modules/admin/auth/services/auth.service';

@Component({
  selector: 'sociuu-cookie-consent-form-dialog',
  templateUrl: './cookie-consent-form-dialog.component.html',
  styleUrls: ['./cookie-consent-form-dialog.component.scss'],
})
export class CookieConsentFormDialogComponent implements OnInit {
  public error: '';
  public state: 'form' | 'details' = 'form';
  public accepted: boolean = false;
  public essentialCookiesChecked: boolean = true;
  public gaTooltipText: string = 'The *_ga cookie* is set by Google Analytics via HubSpot. Sociuu does not use Google Analytics directly on the SaaS platform, but HubSpot may set this for its own usage.';

  constructor(
    public dialogRef: MatDialogRef<CookieConsentFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { },
    private authService: AuthService,
  ) {}

  public ngOnInit(): void {
  }

  public acceptAll(): void {
    this.accepted = true;
    this.authService.handleCookieConsentAccepted();
    this.dialogRef.close(true);
  }

}
